import { Alert, Text, RadioButton } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'

type Props = {
  employeeNameList: string[]
  control: Control<any>
  disabled?: boolean
}

export const ShiftConflictResolution: FC<Props> = ({
  employeeNameList,
  control,
  disabled
}) => {
  const { t } = usePlanningFormTranslation()
  const employeeListStr = employeeNameList.join(', ')

  return (
    <div
      className='rounded-lg bg-neutral-100 p-4'
      data-testid='shift-conflict-resolution'
    >
      <Alert intent='semantic.red' className='mb-4 bg-neutral-50'>
        <Text>
          {t('restForm.shiftConflictResolution.warning', {
            count: employeeNameList.length,
            name: employeeListStr
          })}
        </Text>
      </Alert>
      <Controller
        name='shift_conflict_strategy'
        control={control}
        disabled={disabled}
        render={({ field: { onChange, value } }) => (
          <RadioButton.Group
            label={t('restForm.shiftConflictResolution.question')}
            name='radio-group'
            position='top-stacked'
            value={value}
            onChange={onChange}
            required
          >
            <RadioButton
              label={t('restForm.shiftConflictResolution.choices.delete', {
                count: employeeNameList.length
              })}
              position='right'
              value='delete'
              data-testid='shift-conflict-resolution-delete'
            />
            <RadioButton
              label={t('restForm.shiftConflictResolution.choices.unassign', {
                count: employeeNameList.length
              })}
              position='right'
              value='unassign'
              data-testid='shift-conflict-resolution-unassign'
            />

            <RadioButton
              label={t('restForm.shiftConflictResolution.choices.none')}
              position='right'
              value='none'
              data-testid='shift-conflict-resolution-none'
            />
          </RadioButton.Group>
        )}
      />
    </div>
  )
}
